import { Navigate, Outlet } from "react-router-dom";
import { useJWTAuth } from "./JWTAuthProvider";
import { Layout } from "../components/Layout";

export const ProtectedRoute = () => {
    const { isAuthenticated } = useJWTAuth();

    // Check if the user is authenticated
    if (!isAuthenticated) {
        // If not authenticated, redirect to the login page
        return <Navigate to="/login" replace />;
    }

    // If authenticated, render the child routes
    return <Layout><Outlet /></Layout>;
};